export default __webpack_public_path__ + "assets/images/8fbd48fed515e24b51ae7807f5821c27.png";